import React, {useCallback} from "react";
import {Flex, Image} from "antd";
import {useTranslation} from "react-i18next";
import {getValueFromJSON} from "@components/form/formUtils";
import {ETextAlign} from "@interface/enums";
import {IFormConfig, IFormConfigItem, ISearchListItemConfig} from "@tools/CustomInterfaces";
import Highlight from "@components/Highlight";
import { dateFormat } from "@tools/format";

interface Props {
    item: any
    config: ISearchListItemConfig[]
    formConfig?: IFormConfig
}

const SelectDropdownLabel : React.FC<Props> = (props) => {
    const {item, config, formConfig} = props;
    const { t, i18n } = useTranslation();
    const lang = i18n.language;

    const getFieldName = useCallback((settings, fieldConfig, defaultLang?) => {
        let localeSuffix = ""

        if(fieldConfig?.type === "stringLocale" || settings.locale)
            localeSuffix = `_${defaultLang || lang}`

        const split = settings.name.split(".")
        split[0] = split[0] + localeSuffix
        return  split.join(".")
    }, [lang, formConfig])

    return <Flex justify="stretch">
        {config.map(settings => {
            const fieldConfig : IFormConfigItem["settings"] = formConfig?.fields?.find(item => item.name === settings.name)

            let fieldName = getFieldName(settings, fieldConfig);
            let customStyles: any = {}

            let value = getValueFromJSON(item, fieldName);

            if (!value && settings.locale) {
                fieldName = getFieldName(settings, fieldConfig, "en")
                value = getValueFromJSON(item, fieldName)
            }

            if((fieldConfig?.config?.lookup || settings.lookup) && value){

                value = t(`lookup:${fieldConfig?.config?.lookup || settings.lookup}.${value}`)
            }
            if (settings.type === "image") {
                value = <Image
                    src={value?.indexOf("http") === 0 ? value : `${process.env.REACT_APP_IMAGE_URL}/m_${value}`}
                    style={{maxWidth: "100%", maxHeight: "100%", objectFit: "contain", width: settings.width || 90, height: settings.width || 90}}
                    fallback="data:image/png;base64,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"
                    preview={false}
                />;
                customStyles = {width: settings.width || 90, height: settings.width || 90, textAlign: "center"}
            }
            else if (settings.type === "color") {
                value = <div style={{width: 16, height: 16, maxWidth: 16, backgroundColor: value, marginTop: 3}}/>;
            }
            else if (settings.type === "date") {
                value = dateFormat(value, {...settings.dateFormat && {format: settings.dateFormat}});
            }
            if(value && !settings.locale && !settings.type && item.highlight) {
                value = <Highlight text={value} highlight={item.highlight} />
            }
            if(value || value ===0) {
                return <div
                    key={settings.name}
                    style={Object.assign({
                            flex: `${settings.flex || 0} ${settings.flex || 0} auto`, 
                            padding: settings.padding || "0 4px", 
                            ...settings.color && {color: settings.color}, 
                            textAlign: settings.align || ETextAlign.left,
                            ...!!settings.fontSize && {fontSize: `${settings.fontSize}pt`},
                        }, 
                        customStyles
                    )}
                >
                    {settings.prefix || null}
                    {settings.brackets && "("}
                    {value}
                    {settings.brackets && ")"}
                    {settings.suffix || null}
                </div>
            }

            return null
        })}
        </Flex>
}

export default SelectDropdownLabel
